export default "__VITE_ASSET__DJwLznDt__"